import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import ProposalContainer from "../containers/proposal";
import Footer from "../layouts/footer";
import Header from "../layouts/header/index";
import Layout from "../layouts/index";

const ProposalPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="X Chexo FC || Proposal Turnamen Mini Soccer Alumni" />
                <div className="wrapper proposal-page-wrapper">
                    <Header classOption="hb-border" />
                    <div className="main-content">
                        <ProposalContainer />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default ProposalPage;
